import { Route, Routes } from 'react-router-dom'
import './App.css'
import Dashboard from './routes/dashboard/dashboard.component'
import DashboardHome from './routes/dashboard-home/dashboard-home.component'
import ChartPage from './routes/chart/chart.component' // اضافه کردن کامپوننت نمودار

const App = () => {
  document.title = 'UA014'

  return (
    <Routes>
      <Route path='/' element={<Dashboard />}>
        <Route index element={<DashboardHome />} />
        <Route path='dashboard-home' element={<DashboardHome />} />
        <Route path='chart' element={<ChartPage />} /> {/* مسیر جدید */}
      </Route>
    </Routes>
  )
}

export default App
